
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "DermatomeMapDifferent",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/DermatomeMapDifferent.vue